(function () {
  angular.module('MktzapApp.Factories')
    .factory('EmailBatchService', EmailBatchService);

  EmailBatchService.$inject = ['$resource'];

  function EmailBatchService ($resource) {
    return $resource(apiUrl + '/email-batch', {}, {
      getAllEmailBatchs: { url: apiUrl + '/email-batch/get-all-email-batchs', method: 'GET', params: {}, isArray: false },
      getEmailBatch: { url: apiUrl + '/email-batch/get-email-batch', method: 'GET', params: {}, isArray: false },
    });
  }
})();